import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { getVisualizationsQueryOptions } from '@/lib/queries/view/useViewVisualizations';
import { getLastVisitedVisualization } from './lastVisitedVisualizationView';
import { visualizationTypeToUrlSegment } from './visualizationTypeToUrlSegment';

export async function redirectToLoopVisualizationOfType({
  type,
  org,
  loopId,
  viewId,
  queryClient,
}: {
  type?: VisualizationType;
  org: string;
  loopId: number;
  viewId: number;
  queryClient: QueryClient;
}): Promise<void> {
  // Fetch visualizations using React Query cache (shared with components)
  const visualizations = await queryClient.ensureQueryData(
    getVisualizationsQueryOptions({ orgId: '', loopId, viewId }),
  );

  const preferredType = type ?? getLastVisitedVisualization(viewId);
  const firstVisualization = preferredType
    ? (visualizations.find((v) => v.type === preferredType) ?? visualizations[0])
    : visualizations[0];

  // Redirect to first visualization if any exist
  if (firstVisualization) {
    throw redirect({
      to: `/org/$org/loop/$loopId/visualizations/view/$viewId/${visualizationTypeToUrlSegment(firstVisualization.type)}`,
      params: { org, loopId, viewId },
      replace: true,
    });
  }
}
